export default class ValidationContext {
    constructor() {
        this.errors = [];
        this.stepErrors = [];
        this.routeErrors = [];
    }

    addError(error) {
        this.errors.push(error);
    }

    addStepError(stepError) {
        this.stepErrors.push(stepError);
    }

    addRouteError(routeError) {
        this.routeErrors.push(routeError);
    }

    get hasError() {
        return this.errors.length > 0 || this.stepErrors.length > 0 || this.routeErrors.length > 0;
    }
};